import { Button, Typography } from '@mui/material';
import { Box } from '@mui/system';
import useToggle from 'hooks/useToggle';
import colors from 'styles/colors';
import Form from './Form';

const styles = {
  title: {
    display: 'flex',
    justifyContent: 'space-between',
  },
};

const Setting = ({
  subtitleText, noBorder, FormData,
}) => {
  const [opened, toggle] = useToggle();

  return (
    <Box
      sx={{
        borderBottom: noBorder ? '0' : `1px solid ${colors.border.border_5p}`,
        padding: '24px 0',
      }}
    >
      <Box sx={{ maxHeight: '76px' }}>
        <Box sx={styles.title}>
          <Typography
            variant="h5"
            sx={{ color: colors.text.primary }}
          >
            {FormData.titleText}
          </Typography>
          {FormData.titleText !== 'Email Address' && (
            <Button
              variant="outlined"
              onClick={toggle}
            >
              {opened ? 'Hide' : 'Change'}
            </Button>
          )}
        </Box>
        <Typography
          variant="body1"
          sx={{
            color: colors.text.secondary,
            marginBottom: opened ? '24px' : 0,
          }}
        >
          {subtitleText}
        </Typography>
      </Box>
      <Box>
        {opened && <Form {...FormData} /> }
      </Box>
    </Box>
  );
};

export default Setting;
